import React, { Dispatch, useContext, useEffect } from "react"
import { useDispatch } from "react-redux"
import { RouteProps, useNavigate, useParams } from "react-router-dom"
import { FeatureToggleContext } from "../../config/toggle.context"
import { getUserEntitiesNJourneys } from "../../services/bff-service"
import { setEntities, setEntitiesLoadInProgress } from "../../stores/entity/entity-action"
import { useEntityState } from "../../stores/entity/entity.hooks"
import { setSnackBar } from "../../stores/ui/ui-action"
import FENERGO_CONSTANTS from "../../utils/fenergo-constants"
import { fetchEntityAndJourneyData, fetchJourneyId, getValidJourney, 
         transformMultipleJourneysIntoSingle } from "../../utils/fenergo-utils"
import { setMedalliaCompanyInfo, setMedalliaUserProfile } from "../../utils/medallia-utils"
import CustomLoading from "../custom/custom-loading"

export const JourneyWrapper: React.FC<RouteProps> = ({ children, ...rest }) => {
  const dispatch: Dispatch<any> = useDispatch();
  const navigate = useNavigate();

  const { journeyId, taskId } = useParams<{
    journeyId?: string;
    taskId?: string;
  }>();
  
  const {
    entities, selectedEntity, entitiesLoadInProgress, journeyTasksLoadInProgress, dataGroupsLoadInProgress, initialJourneyTasks, entityDraft
  } = useEntityState();
  const { useToggle } = useContext(FeatureToggleContext);
  const toggleReadableUrl = useToggle("ftReadableUrlPaths");

  useEffect(() => {
    const fetchEntitiesAndJourneys = async () => {
      try {
        if (!entities || !entities.length) {
          dispatch(setEntitiesLoadInProgress(true));
          const fetchedEntities = await getUserEntitiesNJourneys();
          const singleEntity = transformMultipleJourneysIntoSingle(fetchedEntities);
          dispatch(setEntities(singleEntity));
          dispatch(setEntitiesLoadInProgress(false));
  
          if (singleEntity.length === 1) {
            const validJourney = getValidJourney(singleEntity[0]?.company?.journeys);
            if (validJourney?.journeyStatus === FENERGO_CONSTANTS.JOURNEY_STATUSES.DONE) {
              navigate('/portal');
            } else {
              fetchEntityAndJourneyData(
                dispatch,
                navigate,
                singleEntity[0],
                journeyTasksLoadInProgress, 
                journeyId,
                toggleReadableUrl(false, true),
                taskId
              );
            }
          }
        }
      } catch (error) {
        dispatch(setEntitiesLoadInProgress(false));
        dispatch(setSnackBar({
          show: true,
          message: 'Error while calling API',
          description: error.message,
          messageType: 'error'
        }));
      }
    };
  
    fetchEntitiesAndJourneys();
  }, [entities, dispatch, navigate, journeyTasksLoadInProgress, journeyId, taskId]);


  useEffect(() => {
    if(entityDraft?.journeyId && !window["companyInfo"]?.journeyId) {
      setMedalliaCompanyInfo({
        journeyId: entityDraft.journeyId,
        companyName: entityDraft.properties['dbaName']?.value
      });
    }
  }, [entityDraft]);

  useEffect(() => {
    if(entities.length && !window["userProfile"]?.email) {
      const entityToSelect = entities.length > 1 ? entities.find(entity => (fetchJourneyId(entity) === journeyId)) : entities[0];
      setMedalliaUserProfile({
        firstName: entityToSelect?.individual?.properties?.firstName?.value,
        lastName: entityToSelect?.individual?.properties?.lastName?.value,
        email: entityToSelect?.individual?.properties?.email?.value
    });
    }
    if (entities.length > 1 && journeyId && !selectedEntity) {
      // TODO: Remove the journeyInfo undefined check
      const entityToSelect = entities.find(entity => (fetchJourneyId(entity) === journeyId));
      fetchEntityAndJourneyData(dispatch, navigate, entityToSelect, journeyTasksLoadInProgress, journeyId, toggleReadableUrl(false, true));
    }
  }, [entities])

  return (
      <>
        {/* <LoadingOnBackdrop status={entitiesLoadInProgress} message="Loading the prospects..." />
        <LoadingOnBackdrop status={journeyTasksLoadInProgress} message="Loading the prospect journey..." /> */}
        {dataGroupsLoadInProgress && <CustomLoading message='Loading...'/>}
        {!entitiesLoadInProgress && !dataGroupsLoadInProgress && !journeyTasksLoadInProgress && entities && children}
      </>
  );
}